function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1 10.1618C0.861928 10.1618 0.75 10.2737 0.75 10.4118L0.75 11.5882C0.75 11.7263 0.861928 11.8382 1 11.8382L14.6917 11.8382L8.98915 17.5887C8.89664 17.682 8.89212 17.8309 8.97882 17.9297L9.75372 18.812C9.79945 18.8641 9.86473 18.8948 9.934 18.8969C10.0033 18.899 10.0703 18.8723 10.1191 18.8231L17.7024 11.176C17.7991 11.0786 17.7991 10.9214 17.7024 10.824L10.1192 3.17691C10.0704 3.12771 10.0034 3.10096 9.93413 3.10306C9.86487 3.10515 9.79959 3.13589 9.75386 3.18795L8.97884 4.07018C8.89212 4.1689 8.89662 4.31791 8.98915 4.41121L14.6917 10.1618L1 10.1618ZM18.25 21C18.25 21.1381 18.3619 21.25 18.5 21.25L22 21.25C22.1381 21.25 22.25 21.1381 22.25 21L22.25 0.999999C22.25 0.861928 22.1381 0.749999 22 0.749999L18.5 0.749999C18.3619 0.749999 18.25 0.861928 18.25 0.999999L18.25 2.17647C18.25 2.31454 18.3619 2.42647 18.5 2.42647L20.5833 2.42647L20.5833 19.5735L18.5 19.5735C18.3619 19.5735 18.25 19.6855 18.25 19.8235L18.25 21Z",
  fill: "#595959",
  stroke: "#595959",
  strokeWidth: 0.5,
  strokeLinejoin: "round"
});

var SvgLogout = function SvgLogout(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogout, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logout.c569c2e5.svg";
export { ForwardRef as ReactComponent };